var _defs, _circle, _path, _circle2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWheel = function SvgWheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "wheel_svg__Layer_1",
    width: "inherit",
    height: "inherit",
    "data-name": "Layer 1",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".wheel_svg__cls-1{fill:currentColor}.wheel_svg__cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:20px}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 298.88,
    cy: 300.35,
    r: 211.59,
    className: "wheel_svg__cls-2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.88 88.76v423.18M149.26 150.73l299.23 299.23",
    className: "wheel_svg__cls-2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.88,
    cy: 300.35,
    r: 76.12,
    className: "wheel_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.29 300.35h423.17M149.26 449.96l299.23-299.23",
    className: "wheel_svg__cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m394.01 250.43 85.05-77.15c5.14-4.61 13.08-3.77 17.24 1.75 17.74 23.57 28.53 52.57 29.5 83.8.21 6.82-5.52 12.35-12.33 11.98l-112.26.02c-10.41-.56-14.95-13.43-7.19-20.39Z",
    className: "wheel_svg__cls-1"
  })));
};
export default SvgWheel;